<div *ngIf="formGroup" [formGroup]="formGroup" class="formItemsBox">
  <div class="form-item" *ngIf="!unVisibleComp.name">
    <mat-form-field appearance="fill">
      <mat-label>Nom</mat-label>
      <input matInput placeholder="" formControlName="name" />
      <mat-error *ngIf="formGroup.controls.name.hasError('required')"> Nom est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.size">
    <mat-form-field appearance="fill">
      <mat-label>Taille</mat-label>
      <input matInput placeholder="" formControlName="size" type="number" />
      <mat-error *ngIf="formGroup.controls.size.hasError('required')"> Taille est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.hidden"><mat-checkbox formControlName="hidden">Caché</mat-checkbox><br /></div>

  <div class="form-item" *ngIf="!unVisibleComp.parameters">
    <app-ui-list-sub-doc-templatefield id="parameters" [label]="'parameters'" [inputData]="formGroup._parameters">
    </app-ui-list-sub-doc-templatefield>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.values">
    <app-ui-list-sub-doc-templatefield id="values" [label]="'valeurs'" [inputData]="formGroup._values"> </app-ui-list-sub-doc-templatefield>
  </div>
</div>
